'use strict';

/**
 * 判断HUYA 各端内置浏览器userAgent工具类
 * **/
var ClientBrowserUa = /** @class */ (function () {
    /**
     * 构造函数，初始化 User Agent
     */
    function ClientBrowserUa() {
        this.userAgent = navigator.userAgent.toLowerCase();
    }
    /**
     * 获取url参数
     * @param {*} name
     * @param {*} url
     * @returns
     */
    ClientBrowserUa.prototype.getQueryString = function (name, url) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var target = url || window.location.search;
        var result = target.substr(1).match(reg);
        if (result !== null) {
            return result[2];
        }
        return null;
    };
    // 判断当前页面是否在iframe内
    ClientBrowserUa.prototype.isIframeLoaded = function () {
        try {
            // 当前窗口不是顶级，且referrer包含www.huya.com
            return (window.self !== window.top && /www.huya.com/.test(document.referrer));
        }
        catch (_a) {
            return true;
        }
    };
    /**
     * 判断当前设备是否为安卓
     * @returns 当前设备是否为安卓
     */
    ClientBrowserUa.prototype.isAndroid = function () {
        return /android/i.test(this.userAgent);
    };
    /**
     * 判断当前设备是否为 iOS
     * @returns 当前设备是否为 iOS
     */
    ClientBrowserUa.prototype.isIOS = function () {
        return /iphone|ipad|ipod/i.test(this.userAgent);
    };
    /**
     * 判断当前浏览器是否为微信内置浏览器
     * @returns 当前浏览器是否为微信内置浏览器
     */
    ClientBrowserUa.prototype.isWeChat = function () {
        return /micromessenger/i.test(this.userAgent);
    };
    /**
     * 判断当前浏览器是否为移动设备浏览器
     * @returns 当前浏览器是否为移动设备浏览器
     */
    ClientBrowserUa.prototype.isMobile = function () {
        return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(this.userAgent);
    };
    /**
     * 判断当前浏览器是否为 虎牙APP && 小鹿
     * @returns 当前浏览器是否为 虎牙APP && 小鹿
     */
    ClientBrowserUa.prototype.isHuyaApp = function () {
        var isApp = /huya/.test(this.userAgent);
        return this.isMobile() && isApp && !this.isHuyaZs();
    };
    /**
     * 判断当前浏览器是否为 Pc观众客户端
     * @returns 当前浏览器是否为 Pc观众客户端
     */
    ClientBrowserUa.prototype.isHuyaPc = function () {
        return /huya-pc/.test(this.userAgent);
    };
    /**
     * 判断当前浏览器是否为 Pc主播开播客户端
     * @returns 当前浏览器是否为 Pc主播开播客户端
     */
    ClientBrowserUa.prototype.isHuyaPcAnchor = function () {
        return /hyanchor/.test(this.userAgent);
    };
    /**
     * 判断当前浏览器环境是否为 web主站内
     * @returns 当前浏览器是否为 web主站内
     */
    ClientBrowserUa.prototype.isHuyaMainWeb = function () {
        // 获取Url上参数webTTProvidedData,如果有则是web主站互动通道
        var webTTProvidedData = !!this.getQueryString('webTTProvidedData');
        // 获取是否是iframe
        var isWebFrame = this.isIframeLoaded();
        return webTTProvidedData || isWebFrame;
    };
    /**
     * 判断当前浏览器环境是否为 虎牙助手端
     * @returns 当前浏览器是否为 虎牙助手端
     * */
    ClientBrowserUa.prototype.isHuyaZs = function () {
        var isZs = /zs/.test(this.userAgent);
        return this.isMobile() && isZs;
    };
    return ClientBrowserUa;
}());
var index = new ClientBrowserUa();

module.exports = index;
